import { ArrowRight, Scissors, Play, Users, Heart } from "lucide-react";
import { PATREON_URL, CLUB_PRICE, CLUB_SCHEDULE, CLUB_PERKS } from "@/lib/club";
import Footer from "@/components/ui/Footer";

const icons = [Scissors, Play, Users, Heart];

export function LooseThreadsClub() {
  return (
    <div className="club-page">
      <section className="club-page-hero" aria-labelledby="club-page-title">
        <div className="club-page-hero-grid">
          <div>
            <p className="club-label">Loose Threads Club · Chelsea’s Patreon</p>
            <h1 id="club-page-title">Come sew<br /><span>with me.</span></h1>
            <p className="club-page-lead">A project to get excited about. A little help along the way. People who get your sewing chaos.</p>
            <p className="club-page-copy">Hi, I’m Chelsea! Each month we’ll take on one bigger project together in two livestream classes. Clothing, quilts, shoes, bags, handmade gifts—there’s always another creative rabbit hole to explore.</p>
            <a className="club-button" href={PATREON_URL} target="_blank" rel="noopener noreferrer">Join Loose Threads Club <ArrowRight size={18} aria-hidden="true" /></a>
            <p className="club-price-note">{CLUB_PRICE} on Patreon · Replays included · Cancel anytime</p>
            <a className="club-text-link" href="#membership">See membership options <ArrowRight size={16} aria-hidden="true" /></a>
          </div>
          <figure>
            <img src="/chelsea-and-cosmo.jpg" alt="Chelsea and Cosmo in her sewing room, ready for another project" width={1000} height={1333} fetchPriority="high" />
            <figcaption>Your sewing room, my sewing room. Let’s make things together.</figcaption>
          </figure>
        </div>
      </section>
      <section className="club-page-benefits" aria-labelledby="club-benefits-title">
        <div className="club-page-container">
          <h2 id="club-benefits-title">More making. Less figuring it out alone.</h2>
          <div className="club-perk-grid">
            {CLUB_PERKS.map((perk, i) => {
              const Icon = icons[i];
              return <article className="club-perk" key={perk.title}><Icon size={24} aria-hidden="true" /><h3>{perk.title}</h3><p>{perk.description}</p></article>;
            })}
          </div>
          <div className="club-page-schedule"><Scissors size={24} aria-hidden="true" /><div><h3>A regular date with your sewing machine</h3><p>{CLUB_SCHEDULE}, unless otherwise announced.</p><p>Join live to ask questions and troubleshoot, or make it a replay night whenever you have time.</p></div></div>
        </div>
      </section>
      <section id="membership" className="club-page-membership" aria-labelledby="club-membership-title">
        <div className="club-page-container">
          <h2 id="club-membership-title">Find your place in the club.</h2>
          <p className="club-page-copy">Make with us, or simply help keep the creative fun going.</p>
          <div className="club-plan-grid">
            <article className="club-plan club-plan-featured">
              <p className="club-label">For making together</p>
              <h3>Loose Threads Club Member</h3>
              <p className="club-plan-price">$25<span>/month</span></p>
              <ul><li>Two livestream classes each month</li><li>Replays to revisit at your own pace</li><li>Community challenges and a place to share</li><li>Member perks and merch discounts</li><li>Project discounts when available</li></ul>
              <a className="club-button" href={PATREON_URL} target="_blank" rel="noopener noreferrer">Join the project club <ArrowRight size={18} aria-hidden="true" /></a>
              <p className="club-price-note">Patterns and supplies aren’t included unless stated.</p>
            </article>
            <article className="club-plan">
              <p className="club-label">For cheering us on</p>
              <h3>Thread Friend</h3>
              <p className="club-plan-price">$3<span>/month</span></p>
              <p>A little support goes a long way. Help me keep creating sewing content and trying new projects.</p>
              <ul><li>Merch discount</li><li>Occasional discount codes when available</li><li>My eternal gratitude for supporting the fun</li></ul>
              <p className="club-plan-exclusion">This supporter tier doesn’t include livestream classes, replays, or project club perks.</p>
              <a className="club-text-link" href={PATREON_URL} target="_blank" rel="noopener noreferrer">Become a Thread Friend <ArrowRight size={16} aria-hidden="true" /></a>
            </article>
          </div>
          <p className="club-price-note">Choose your tier and manage your membership on Patreon. Cancel anytime.</p>
        </div>
      </section>
      <section className="club-page-faq" aria-labelledby="club-faq-title">
        <div className="club-page-container">
          <h2 id="club-faq-title">Before you pull up a chair.</h2>
          <details><summary>What if I can’t make the live classes?</summary><p>Replays are included in the $25 project club. Watch when you have time, pause while you sew, and come back to a step whenever you need it.</p></details>
          <details><summary>Are patterns and supplies included?</summary><p>Patterns and supplies are separate unless specifically stated for a project. I’ll share project discounts when they’re available.</p></details>
          <details><summary>What kinds of projects will we make?</summary><p>Projects may include clothing, quilts, shoemaking, handmade gifts, and bags. We work through one bigger project each month across two livestream classes.</p></details>
          <details><summary>How do I join?</summary><p>Choose a membership on Patreon using any of the join buttons. The $25 tier includes live classes and replays; the $3 Thread Friend tier supports my content without the project club benefits.</p></details>
          <div className="club-page-final"><p>Fun, a little unhinged, and definitely thread-covered.</p><a className="club-button" href={PATREON_URL} target="_blank" rel="noopener noreferrer">Come sew with me <ArrowRight size={18} aria-hidden="true" /></a></div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
